import * as THREE from 'three'

export default class InformationSection
{
    constructor(_options)
    {
        this.time = _options.time
        this.resources = _options.resources
        this.objects = _options.objects
        this.areas = _options.areas
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.setStatic()
        //this.setBaguettes()
        this.setLinks()
        this.setActivities()
        this.setTiles()
    }

    setStatic()
    {
        this.objects.add({
            base: this.resources.items.informationStaticBase.scene,
            collision: this.resources.items.informationStaticCollision.scene,
            floorShadowTexture: this.resources.items.informationStaticFloorShadowTexture,
            offset: new THREE.Vector3(this.x, this.y, 0),
            mass: 0
        })
    }

    //面包
    setBaguettes()
    {
        this.baguettes = {}

        this.baguettes.x = - 4
        this.baguettes.y = 6

        this.baguettes.a = this.objects.add({
            base: this.resources.items.informationBaguetteBase.scene,
            collision: this.resources.items.informationBaguetteCollision.scene,
            offset: new THREE.Vector3(this.x + this.baguettes.x - 0.56, this.y + this.baguettes.y - 0.666, 0.2),
            rotation: new THREE.Euler(0, 0, - Math.PI * 37 / 180),
            duplicated: true,
            shadow: { sizeX: 0.6, sizeY: 3.5, offsetZ: - 0.15, alpha: 0.35 },
            mass: 1.5,
            // soundName: 'woodHit'
        })

        this.baguettes.b = this.objects.add({
            base: this.resources.items.informationBaguetteBase.scene,
            collision: this.resources.items.informationBaguetteCollision.scene,
            offset: new THREE.Vector3(this.x + this.baguettes.x - 0.8, this.y + this.baguettes.y - 2, 0.5),
            rotation: new THREE.Euler(0, - 0.5, Math.PI * 60 / 180),
            duplicated: true,
            shadow: { sizeX: 0.6, sizeY: 3.5, offsetZ: - 0.15, alpha: 0.35 },
            mass: 1.5,
            sleep: false,
            // soundName: 'woodHit'
        })
    }

    setLinks()
    {
        this.links = {}
        this.links.x = 1.95
        this.links.y = - 1.5
        this.links.halfExtents = {}
        this.links.halfExtents.x = 1
        this.links.halfExtents.y = 1
        this.links.distanceBetween = 2.4
        this.links.labelWidth = this.links.halfExtents.x * 2 + 1
        this.links.labelGeometry = new THREE.PlaneBufferGeometry(this.links.labelWidth, this.links.labelWidth * 0.25, 1, 1)
        this.links.labelOffset = - 1.6
        this.links.items = []

        this.links.container = new THREE.Object3D()
        this.links.container.matrixAutoUpdate = false
        this.container.add(this.links.container)

        this.links.options = [
            {
                href: 'tencent://Message/?Uin=937040147&websiteName=15028582175&Menu=yes',
                labelTexture: this.resources.items.informationContactQQLabelTexture
            },
            {
                href: 'https://gitee.com/hoppin',
                labelTexture: this.resources.items.informationContactGithubLabelTexture
            },
            {
                message: 'wx:HOPPIN_HAZZ',
                labelTexture: this.resources.items.informationContactWXLabelTexture
            },
            {
                href: 'mailto:anmiezata@163.com',
                labelTexture: this.resources.items.informationContactMailLabelTexture
            }
        ]

        let i = 0
        for(const _option of this.links.options)
        {
            const item = {}
            item.x = this.x + this.links.x + this.links.distanceBetween * i
            item.y = this.y + this.links.y
            item.href = _option.href

            item.area = this.areas.add({
                position: new THREE.Vector2(item.x, item.y),
                halfExtents: new THREE.Vector2(this.links.halfExtents.x, this.links.halfExtents.y)
            })
            item.area.on('interact', () =>
            {
                if(_option.href!==undefined){
                    window.open(_option.href, '_blank')
                }else{
                    alert(_option.message)
                }

            })

            item.texture = _option.labelTexture
            item.texture.magFilter = THREE.NearestFilter
            item.texture.minFilter = THREE.LinearFilter

            item.labelMesh = new THREE.Mesh(this.links.labelGeometry, new THREE.MeshBasicMaterial({ wireframe: false, color: 0xffffff, alphaMap: _option.labelTexture, depthTest: true, depthWrite: false, transparent: true }))
            item.labelMesh.position.x = item.x + this.links.labelWidth * 0.5 - this.links.halfExtents.x
            item.labelMesh.position.y = item.y + this.links.labelOffset
            item.labelMesh.matrixAutoUpdate = false
            item.labelMesh.updateMatrix()
            this.links.container.add(item.labelMesh)

            this.links.items.push(item)
            i++
        }
    }

    setActivities()
    {
        this.activities = {}
        this.activities.x = this.x + 0
        this.activities.y = this.y - 10
        this.activities.multiplier = 5.5

        this.activities.geometry = new THREE.PlaneBufferGeometry(2 * this.activities.multiplier, 1 * this.activities.multiplier, 1, 1)

        this.activities.texture = this.resources.items.informationActivitiesTexture
        this.activities.texture.magFilter = THREE.NearestFilter
        this.activities.texture.minFilter = THREE.LinearFilter

        this.activities.material = new THREE.MeshBasicMaterial({ wireframe: false, color: 0xffffff, alphaMap: this.activities.texture, transparent: true })

        this.activities.mesh = new THREE.Mesh(this.activities.geometry, this.activities.material)
        this.activities.mesh.position.x = this.activities.x
        this.activities.mesh.position.y = this.activities.y
        this.activities.mesh.matrixAutoUpdate = false
        this.activities.mesh.updateMatrix()
        this.container.add(this.activities.mesh)
    }

    // setDota2()
    // {
    //     // Set up
    //     this.dota2 = {}
    //     this.dota2.x = this.x
    //     this.dota2.y = this.y
    //     this.dota2.multiplier = 5.5

    //     // Geometry
    //     this.dota2.geometry = new THREE.PlaneBufferGeometry(2 * this.dota2.multiplier, 1 * this.dota2.multiplier, 1, 1)
    //     console.log(this.resources.items)
    //     // Texture
    //     this.dota2.texture = this.resources.items.dota2BaseTexture
    //     this.dota2.texture.magFilter = THREE.NearestFilter
    //     this.dota2.texture.minFilter = THREE.LinearFilter

    //     // Material
    //     this.dota2.material = new THREE.MeshBasicMaterial({ wireframe: false, color: 0xffffff, alphaMap: this.dota2.texture, transparent: true })

    //     // Mesh
    //     this.dota2.mesh = new THREE.Mesh(this.dota2.geometry, this.dota2.material)
    //     this.dota2.mesh.position.x = this.dota2.x
    //     this.dota2.mesh.position.y = this.dota2.y
    //     this.dota2.mesh.matrixAutoUpdate = false
    //     this.dota2.mesh.updateMatrix()
    //     this.container.add(this.dota2.mesh)
    // }

    setTiles()
    {
        this.tiles.add({
            start: new THREE.Vector2(this.x - 1.2, this.y + 13),
            delta: new THREE.Vector2(0, - 20)
        })
    }
}
